<template>
  <div class="content">
    <el-row style="width: 94%;
    padding-top: 3%;
    margin-left: 3%;
    background-color: white;
    text-align: left;
    font-family: Calibri;
    padding-bottom:200px;">
      <el-col>
        <el-row class="r_title">Wheat distribution prediction </el-row>
        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Environmental variables: this study considered that the cultivation of wheat is affected by climate and soil (Motuma, Suryabhagavan, & Balakrishnan, 2016). Hence, on the basis of previous research, we established an environment variables system, including the following variables: ≥0°C cumulative temperature, annual precipitation, annual average temperature, average temperature of the coldest month (Jing-Song et al., 2012; L. Wang et al., 2016)，pH, drainage, conductivity, exchangeable sodium percentage, soil property and soil depth (Mendas & Delali, 2012; Wandahwa & Van Ranst, 1996; L. Wang et al., 2016)。Considering that terrain has a great influence on the convenience of wheat cultivation, this study also chose slope as an environmental variable.
        </el-row>
        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Samples: According to <span style="font-style: italic; font-weight: bold;">Harvested Area and Yield for 175 Crops year 2000 15,500</span> samples, which accounted for approximately 5% of all grids, was selected. A total of 75% of these samples were used for model training and the remaining 25% were used for validation.
          <br/>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          The Maxent model was trained to predict future land suitability for wheat cultivation for 2010s (base-term), 2030s (near-term), and 2050s (medium-term) periods under different future climate scenarios.
          <br/>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Specific process reference “The potential global distribution and dynamics of wheat under multiple climate change scenarios” (Yue, Zhang, & Shang, 2019).
        </el-row>



        <el-row class="r_title" style="margin-top: 30px;">Rice distribution prediction  </el-row>
        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          MaxEnt combines the data on the presence of a given species within a grid with environmental variables representing different environmental gradients within that grid to judge whether the area is suitable for a particular species. The overall research framework for the study is shown in Figure 1.
        </el-row>
        <el-row style="text-align: center;padding-top: 10px;">
          <img src="http://bunjs.aiside.top/4-1.png"/><br/>
          <span>Fig. 1 Research framework for predicting rice suitability</span>
        </el-row>
        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Environmental variables and Samples: After the selection of sample points and environment variables (Su et al., 2021), a total of 2228 samples and 17 environment variables were used in prediction future suitable areas for rice.
        </el-row>
        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          The Maxent model was trained to predict future land suitability for rice cultivation for 2010s (base-term), 2030s (near-term), and 2050s (medium-term) periods under different future climate scenarios. In order to reduce errors, the number of simulations is 30 times, and the average result is the final result.
        </el-row>

        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          To balance the supply and demand of rice among countries, this study redistributed future rice cultivation. On the supply side, we used suitability changes to predict the initial rice harvest area as the starting value of the iteration. The rice harvest area was adjusted by comparing the countries’ rice supply and demand. If the supply exceeded demand, reduced rice harvest area, and vice versa. This model can be expressed as a multi-objective optimization model (equation 1-4).
        </el-row>
        <el-row style="text-align: center;">
          <img src="http://bunjs.aiside.top/4-3.png"/>
        </el-row>


        <el-row class="r_title" style="margin-top: 30px;">Maize distribution prediction</el-row>
        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          With reference to the rice distribution prediction method, the number of maize sample points selected is 5548, and 16 environment variables were selected for maize potential distribution prediction. Besides, referring to the redistribution method of rice cultivation, we redistributed maize cultivation among countries on the basis of natural maize potential distribution.
        </el-row>



      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "GlobalCropDistribution"
  }
</script>

<style scoped>


  .r_title{
    font-weight: bold;
    font-size: 2.5rem;
  }
  .content{
    overflow-y: scroll;
    line-height: 40px;
    font-size: 2.2rem;
  }
  .content::-webkit-scrollbar {
    display: none;/*隐藏滚动条*/
  }
</style>



// WEBPACK FOOTER //
// src/view/BSD/About/GlobalCropDistribution.vue